<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            label: String,
            value: [String, Number, Array],
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            multiple:{
                type: Boolean,
                default: false,
            },
            multipleMini:{
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                val: this.value,
            }
        },
        methods: {
            ...mapActions({
                get_list: 'dictionary/currency/get_list'
            }),
            change(v) {
                this.$emit('change', v);
            }
        },
        computed: {
            ...mapState('dictionary/currency', {
                load: 'load',
                list: 'list',
            }),
            ...mapGetters('dictionary/currency', {
                getById: 'getById',
            }),

        },
        watch: {
            value(v) {
                this.val = v;
            },
            val(v) {
                this.$emit('input', v);
            },
        },
        components: {},
        mounted() {
            this.get_list();

        },
        destroyed() {
        },
    }
</script>
<template>
    <div class="input-currency"
         :class="{'mini--multiple': multiple&&multipleMini}">
        <div class="el-input-group el-input--mini" :class="{'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <el-select
                    v-model="val"
                    :disabled="disabled"
                    :clearable="clearable"
                    :collapse-tags="multiple"
                    :multiple="multiple"
                    @change="change"
                    filterable
            >
                <el-option
                        v-for="item in list"
                        :value="item.value"
                        :key="item.value"
                        :label="item.label"
                ></el-option>
            </el-select>
            <i
                    v-if="multiple && multipleMini && clearable && val && val.length"
                    title="Очистить список"
                    @click="change([])"
                    class="el-select__caret el-input__icon el-icon-circle-close is-show-close"
            ></i>
        </div>
        <div class="input__load" v-show="load">
            <i class="el-icon-loading"></i> Загрузка...
        </div>
    </div>
</template>
<style lang="scss">
    .input-currency {
        position: relative;
        .el-select {
            width: 100%;
        }
        .el-select__tags{
            max-width: 224px;
            line-height: 28px;
            height: 28px;
        }
        .el-select__multiple-text{
            font-size: 12px;
        }
    }
</style>
